module.exports = __webpack_public_path__ + "static/media/thermometer-empty.8b987b47.svg";